module.exports = __webpack_public_path__ + "img/1.9e02950a.png";